import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgIconActivity = (props) => /* @__PURE__ */ _jsx("svg", {
	width: "1em",
	height: "1em",
	viewBox: "0 0 15 15",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M7.5 0C3.375 0 0 3.375 0 7.5C0 11.625 3.375 15 7.5 15C11.625 15 15 11.625 15 7.5C15 3.375 11.625 0 7.5 0ZM7.5 13.125C4.6875 13.125 2.4375 11.0625 1.96875 8.4375H5.0625L6.46875 7.03125L9.28125 10.7812L11.625 8.4375H13.0312C12.5625 11.0625 10.3125 13.125 7.5 13.125ZM10.875 6.5625L9.46875 7.96875L6.65625 4.21875L4.3125 6.5625H1.96875C2.4375 3.9375 4.6875 1.875 7.5 1.875C10.3125 1.875 12.5625 3.9375 13.0312 6.5625H10.875Z",
		fill: "currentColor"
	})
});
export default SvgIconActivity;
